<template>
  <div class="" @focusin="selectOnFocus">
    <VuePhoneNumberInput
      v-model="vModel"
      color="#00B9E8"
      error-color="#EA5455"
      :error="!!errors"
      :countriesHeight="25"
      :default-country-code="phoneCode ?? 'US'"
      @update="setValue"
    />
  </div>
</template>
<script>
import "vue-phone-number-input/dist/vue-phone-number-input.css"
import VuePhoneNumberInput from "vue-phone-number-input"

export default {
  name: "PhoneInput",
  components: { VuePhoneNumberInput },
  props: ["errors", "value", "phoneCode"],
  mounted() {
  },
  data() {
    return {
      isValid: null,
      vModel: this.value
    }
  },
  methods: {
    setValue(event) {
      console.log(event)
      console.log(event.formattedNumber)
      this.$emit("input", event)
      this.isValid = event.isValid
    },
    selectOnFocus(event) {
      const input = event.target
      if (input && input.tagName === "INPUT") {
        setTimeout(() => input.select(), 0)
      }
    }
  }
}
</script>

<style lang="scss">
@import "vue-phone-number-input/dist/vue-phone-number-input.css";

.vue-phone-number-input {
  z-index: 100;
  position: relative;
}

// Admin's trillion.scss applies `form { overflow: hidden; }` globally, which clips
// the absolutely-positioned country-code dropdown to the form's box. Only forms
// that actually contain the phone input need to opt out.
form:has(.vue-phone-number-input) {
  overflow: visible;
}
</style>
